/**
 * Creates a rounded rectangle on a canvas 2D context
 * @param {CanvasRenderingContext2D}  ctx
 * @param {Number}                    x
 * @param {Number}                    y
 * @param {Number}                    width
 * @param {Number}                    height
 * @param {Number}                    radius
 */
function round2DContextPath(ctx, x, y, width, height, radius) {
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();
}

/**
 * Truncates and adds a trailing ellipsis to a string so that it does not exceed the given width
 * @param {CanvasRenderingContext2D}  ctx
 * @param {string}                    str
 * @param {Number}                    maxWidth
 */
function fittingString(ctx, str, maxWidth) {
  let { width } = ctx.measureText(str);
  const ellipsis = '…';
  const ellipsisWidth = ctx.measureText(ellipsis).width;
  if (width <= maxWidth || width <= ellipsisWidth) {
    return str;
  }
  let len = str.length;
  while (width >= maxWidth - ellipsisWidth && len > 0) {
    len -= 1;
    str = str.substring(0, len);
    ({ width } = ctx.measureText(str));
  }
  return str + ellipsis;
}

export { round2DContextPath, fittingString };
